import Vue from 'vue';

Vue.component('e-invoice-business', () =>
    import(/* webpackChunkName: 'e-invoice' */ './taxpayer/e-invoice-business.vue'),
);

Vue.component('e-invoice-business-create', () =>
    import(/* webpackChunkName: 'e-invoice' */ './taxpayer/e-invoice-business-create.vue'),
);

Vue.component('e-invoice-business-edit', () =>
    import(/* webpackChunkName: 'e-invoice' */ './taxpayer/e-invoice-business-edit.vue'),
);

Vue.component('e-invoice-outlet', () =>
    import(/* webpackChunkName: 'e-invoice' */ './taxpayer/e-invoice-outlet.vue'),
);

Vue.component('e-invoice-outlet-edit', () =>
    import(/* webpackChunkName: 'e-invoice' */ './taxpayer/e-invoice-outlet-edit.vue'),
);

Vue.component('e-invoice', () =>
    import(/* webpackChunkName: 'e-invoice' */ './invoice/e-invoice.vue'),
);

Vue.component('e-invoice-summary', () =>
    import(/* webpackChunkName: 'e-invoice' */ './invoice/e-invoice-summary.vue'),
);

Vue.component('e-invoice-consolidated', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated.vue'),
);

Vue.component('e-invoice-consolidated-summary', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-summary.vue'),
);

Vue.component('e-invoice-consolidated-show', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-show.vue'),
);

Vue.component('e-invoice-consolidated-show-report', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-show-report.vue'),
);

Vue.component('e-invoice-consolidated-show-detail', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-show-detail.vue'),
);

Vue.component('e-invoice-consolidated-show-vuetable', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-show-vuetable.vue'),
);

Vue.component('e-invoice-consolidated-show-taxable', () =>
    import(/* webpackChunkName: 'e-invoice' */ './consolidated/e-invoice-consolidated-show-taxable.vue'),
);

Vue.component('e-invoice-setting', () =>
    import(/* webpackChunkName: 'e-invoice' */ './setting/e-invoice-setting.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/e-invoice/index.js